import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export type EmptyCollapsableProps = {
  children: React.ReactNode;
  title?: React.ReactNode;
  collapsed?: boolean;

  containerClass?: string;
  headerClass?: string;
  bodyClass?: string;

  iconOpened?: React.ReactNode;
  iconClosed?: React.ReactNode;
};

const EmptyCollapsable: React.FC<EmptyCollapsableProps> = ({
  children,
  title = "Ordered By",
  collapsed = false,

  containerClass = "border border-gray-200 rounded-xl bg-white shadow-sm",
  headerClass =
    "px-4 py-3 flex items-center justify-between text-sm font-semibold text-gray-800 hover:bg-gray-50",
  bodyClass = "px-4 pb-4 text-sm text-gray-600",

  iconOpened,
  iconClosed,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);

  return (
    <div className={`w-full transition-all ${containerClass}`}>
      {/* Header */}
      <button
        type="button"
        onClick={() => setIsCollapsed((p) => !p)}
        className={`w-full text-left rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 ${headerClass}`}
      >
        <div className="flex w-full">{title}</div>

        <span className="ml-2 flex items-center text-gray-400 hover:text-gray-500 hover:scale-110">
          {isCollapsed
            ? iconOpened ?? <ChevronDown size={18} />
            : iconClosed ?? <ChevronUp size={18} />}
        </span>
      </button>

      {/* Body */}
      <div
        className={`grid transition-all duration-300 ease-in-out ${
          isCollapsed ? "grid-rows-[0fr] opacity-0" : "grid-rows-[1fr] opacity-100"
        }`}
      >
        <div className="overflow-hidden">
          <div className={bodyClass}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default EmptyCollapsable;